import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _get from 'lodash/get';
import _head from 'lodash/head';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import _keyBy from 'lodash/keyBy';
import _isString from 'lodash/isString';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { FIELD_IDS, FIELD_NAMES } from './multiSort.constants';
var getDropDownOption = function getDropDownOption() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
    key = _ref.key,
    Header = _ref.Header,
    displayName = _ref.displayName;
  return {
    value: key,
    label: _isString(Header) ? Header : displayName
  };
};
export var getOptionsFromColumns = function getOptionsFromColumns(columns, values) {
  var sortDetailsByKey = _keyBy(values[FIELD_NAMES.SORT_PREFERENCES], FIELD_IDS.SORT_FIELD);
  var columnsByKey = _keyBy(columns, 'key');
  var sortableColumns = _filter(columns, function (column) {
    return (column === null || column === void 0 ? void 0 : column.sortable) && (column === null || column === void 0 ? void 0 : column.key) && _isEmpty(sortDetailsByKey[column.key]);
  });
  return _map(values[FIELD_NAMES.SORT_PREFERENCES], function (row) {
    return _sortBy(_map([].concat(_toConsumableArray(sortableColumns), _toConsumableArray(!_isEmpty(row[FIELD_IDS.SORT_FIELD]) ? [columnsByKey[row[FIELD_IDS.SORT_FIELD]]] : [])), getDropDownOption), ['label']);
  });
};
export var getRowIndex = function getRowIndex(params) {
  return _head(_get(params, 'nestingPath'));
};
export var setGetValueFromOnChange = function setGetValueFromOnChange(_nestingPath, params) {
  return _get(params, 'payload.value');
};